define('mbAModelCreateEditLayoutView',[
  'module',
  'marionette',
  'backbone',
  'dialogFormView',
  'template!mbAModelCreateEditLayoutTpl',
  'savingBehavior',
  'bootbox',
  'underscore',
  'app'
], function(
  module,
  Marionette,
  Backbone,
  DialogFormView,
  createEditLayoutTpl,
  SavingBehavior,
  bootbox,
  _,
  App
) {
  'use strict';

  var CreateEditLayoutView = DialogFormView.extend({
    template: createEditLayoutTpl,

    ui: {
      input: '.js-info-input',
      cycler: '#cycler',
      extractor: '#extractor',
      dispatcher: '#dispatcher',
      other: '#other'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input' : 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm',
      'change @ui.cycler' : 'onChangeCycler',
      'change @ui.extractor' : 'onChangeExtractor',
      'change @ui.dispatcher' : 'onChangeDispatcher',
      'change @ui.other' : 'onChangeOther'
    },

    regions: {
    },

    behaviors: {
      Saving: {
        behaviorClass: SavingBehavior
      }
    },

    modelEvents: {
      sync: 'onSave',
      error: 'onSaveError'
    },

    fieldsToValidate: [
      {name: 'code', type: 'required'},
      {name: 'name', type: 'required'}
    ],

    initialize: function(options) {
      this.model = options.mbamodelModel.clone();
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.newItem = this.options.newItem;
      return templateData;
    },

    onShow: function() {
      $.material.init();

      this.ui.cycler.prop('checked', this.model.get('cycler'));
      this.ui.extractor.prop('checked', this.model.get('extractor'));
      this.ui.dispatcher.prop('checked', this.model.get('dispatcher'));
      this.ui.other.prop('checked', this.model.get('other'));

      this.triggerMethod('enable:cancel:confirm');
    },

    onConfirm: function() {
      if(this.validate(this.fieldsToValidate)) {
        this.model.save();
      }
    },

    onSave: function(model) {
      var modelJSON = model.toJSON();
      this.options.mbamodelModel.set(modelJSON);
      this.triggerMethod('saved');
      App.trigger('mbamodel:header:rerender', modelJSON);
      App.navigate('superAdmin/mbamodels/' + model.get('secId'), {trigger: true});
      this.hide();
    },

    hide: function() {
      this.triggerMethod('hide');
      this.box.modal('hide');
      this.destroy();
      if (App.getCurrentRoute() ===  'superAdmin/mbamodels/new') {
        App.navigate('superAdmin/mbamodels', {trigger: true});
      }
    },

    onSaveError: function(model, response) {
      if(response.status === 409) {
        this.onDuplicateCode();
        this.triggerMethod('hide:label');
      }
    },

    onDuplicateCode: function() {
      this.ui.endUserIdInput.popover('show');
      this.ui.endUserIdInput.addClass('invalid');
      this.ui.endUserIdInput.closest('div[data-field-name=code').addClass('has-error');
    },

    onChangeCycler: function() {
      this.model.set('cycler',this.ui.cycler.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    },

    onChangeExtractor: function() {
      this.model.set('extractor',this.ui.extractor.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    },

    onChangeDispatcher: function() {
      this.model.set('dispatcher',this.ui.dispatcher.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    },

    onChangeOther: function() {
      this.model.set('other',this.ui.other.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    }
  });

  module.exports = CreateEditLayoutView;
});
